'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./search/search'));
    processInclude(require('./product/addtowishlist'));
    processInclude(require('./weddingRegistry/addToRegistry'));
});

require('ion-rangeslider');
